import React from "react";
import { Typography } from "@mui/material";

// Parses [Speaker 1 00:03] → returns seconds (3)
const parseTimeStamp = (str) => {
  const match = str.match(/\[(?:Speaker \d+ )?(\d{2}):(\d{2})\]/);
  if (!match) return null;
  const min = parseInt(match[1], 10);
  const sec = parseInt(match[2], 10);
  return min * 60 + sec;
};

// Renders the transcription with clickable timestamps
const TranscriptionText = ({ text, onSeek }) => {
  const regex = /\[(Speaker \d+ \d{2}:\d{2})\]/g;
  let lastIndex = 0;
  let elements = [];
  let match;
  let key = 0;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      elements.push(text.slice(lastIndex, match.index));
    }
    const timeSec = parseTimeStamp(match[0]);
    elements.push(
      <span
        key={key++}
        style={{
          color: "blue",
          cursor: "pointer",
          textDecoration: "underline",
          marginRight: 4,
        }}
        onClick={() => onSeek(timeSec)}
      >
        {match[0]}
      </span>
    );
    lastIndex = regex.lastIndex;
  }
  if (lastIndex && text && lastIndex < text.length) {
    elements.push(text.slice(lastIndex));
  }

  return (
    <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
      {elements}
    </Typography>
  );
};

export default TranscriptionText;
